/**
 * 加载
 *
 * @author yusangeng@outlook.com
 */
import { __assign, __awaiter, __generator } from "tslib";
import { installCSS } from './installer/css';
import { installJS } from './installer/js';
/**
 * 加载一个完整模块.
 *
 * module中最后一个js会以模拟的AMD格式加载, 如果要导出接口, 最后一个js请使用UMD格式.
 *
 * @export
 * @param {ModuleInfo} module 模块信息
 * @returns {Promise<any>}
 */
export function importModule(module) {
    return __awaiter(this, void 0, void 0, function () {
        var js, css, umd, crossOrigin, ret;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    js = module.js, css = module.css, umd = module.umd, crossOrigin = module.crossOrigin;
                    return [4 /*yield*/, installCSS(css)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, installJS(js, {
                            umd: typeof umd === 'undefined' ? true : umd,
                            crossOrigin: typeof crossOrigin === 'undefined' ? 'anonymous' : crossOrigin
                        })];
                case 2:
                    ret = _a.sent();
                    return [2 /*return*/, ret];
            }
        });
    });
}
var defaultImportScriptOptions = {
    umd: true,
    crossOrigin: 'anonymous'
};
/**
 * 加载一个js脚本.
 *
 * @export
 * @param {string} url 脚本地址
 * @param {ImportScriptOptions} [options={ umd: true }] 配置项
 * @returns {Promise<any>}
 */
export function importScript(url, options) {
    if (options === void 0) { options = defaultImportScriptOptions; }
    return __awaiter(this, void 0, void 0, function () {
        var opt, ret;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opt = __assign(__assign({}, defaultImportScriptOptions), options);
                    return [4 /*yield*/, importModule(__assign({ js: [url], css: [] }, opt))];
                case 1:
                    ret = _a.sent();
                    return [2 /*return*/, ret];
            }
        });
    });
}
/**
 * 加载一个css文件.
 *
 * @export
 * @param {string} url css地址
 * @returns {Promise<any>}
 */
export function importStyle(url) {
    return __awaiter(this, void 0, void 0, function () {
        var ret;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, importModule({ css: [url], js: [] })];
                case 1:
                    ret = _a.sent();
                    return [2 /*return*/, ret];
            }
        });
    });
}
export default { importModule: importModule, importScript: importScript, importStyle: importStyle };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wb3J0ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW1wb3J0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRzs7QUFFSCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0saUJBQWlCLENBQUE7QUFDNUMsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGdCQUFnQixDQUFBO0FBYzFDOzs7Ozs7OztHQVFHO0FBQ0gsTUFBTSxVQUFnQixZQUFZLENBQUMsTUFBa0I7Ozs7OztvQkFDM0MsRUFBRSxHQUE0QixNQUFNLEdBQWxDLEVBQUUsR0FBRyxHQUF1QixNQUFNLElBQTdCLEVBQUUsR0FBRyxHQUFrQixNQUFNLElBQXhCLEVBQUUsV0FBVyxHQUFLLE1BQU0sWUFBWCxDQUFXO29CQUU1QyxxQkFBTSxVQUFVLENBQUMsR0FBRyxDQUFDLEVBQUE7O29CQUFyQixTQUFxQixDQUFBO29CQUNULHFCQUFNLFNBQVMsQ0FBQyxFQUFFLEVBQUU7NEJBQzlCLEdBQUcsRUFBRSxPQUFPLEdBQUcsS0FBSyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsR0FBRzs0QkFDNUMsV0FBVyxFQUFFLE9BQU8sV0FBVyxLQUFLLFdBQVcsQ0FBQyxDQUFDLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxXQUFXO3lCQUM1RSxDQUFDLEVBQUE7O29CQUhJLEdBQUcsR0FBRyxTQUdWO29CQUVGLHNCQUFPLEdBQUcsRUFBQTs7OztDQUNYO0FBT0QsSUFBTSwwQkFBMEIsR0FBRztJQUNqQyxHQUFHLEVBQUUsSUFBSTtJQUNULFdBQVcsRUFBRSxXQUFXO0NBQ3pCLENBQUE7QUFFRDs7Ozs7OztHQU9HO0FBQ0gsTUFBTSxVQUFnQixZQUFZLENBQ2hDLEdBQVcsRUFDWCxPQUF5RDtJQUF6RCx3QkFBQSxFQUFBLG9DQUF5RDs7Ozs7O29CQUVuRCxHQUFHLHlCQUFRLDBCQUEwQixHQUFLLE9BQU8sQ0FBRSxDQUFBO29CQUM3QyxxQkFBTSxZQUFZLFlBQUcsRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxFQUFFLEVBQUUsSUFBSyxHQUFHLEVBQUcsRUFBQTs7b0JBQXhELEdBQUcsR0FBRyxTQUFrRDtvQkFDOUQsc0JBQU8sR0FBRyxFQUFBOzs7O0NBQ1g7QUFFRDs7Ozs7O0dBTUc7QUFDSCxNQUFNLFVBQWdCLFdBQVcsQ0FBQyxHQUFXOzs7Ozt3QkFDL0IscUJBQU0sWUFBWSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxDQUFDLEVBQUE7O29CQUFoRCxHQUFHLEdBQUcsU0FBMEM7b0JBQ3RELHNCQUFPLEdBQUcsRUFBQTs7OztDQUNYO0FBRUQsZUFBZSxFQUFFLFlBQVksY0FBQSxFQUFFLFlBQVksY0FBQSxFQUFFLFdBQVcsYUFBQSxFQUFFLENBQUEifQ==